module.exports = __webpack_public_path__ + "img/bind-card-passed.d168d560.png";